import $http from '../../axios'
import {Notification} from "element-ui";

export async function fetchOrders ({ commit, state, dispatch }, requestParameters = { params: state.params }) {
    commit('setPreloader', true)
	await $http.get('/api/pedidos-vendedor', requestParameters).then(async (response) => {
        if (Object.keys(response.data) != '') {

            const documents = response.data.data;

            commit('setOrders', documents)

            let document_ids = []

            documents.data.map(d => {
                document_ids.push(d.id)
            })

            if (document_ids.length) {
                //await dispatch('fetchUnds', document_ids)
            }
        } else {
            commit('setOrders', '')
        }
    }).catch((error) => {
		Notification.error({
			title: '¡Error!',
			message: error.message,
			type: 'error',
			duration: 1500,
			customClass: 'notification-box'
		})
		commit('error', error.message)
	})
    commit('setPreloader', false)
}

/**
 * obtenemos y seteamos los produtos de un documento
 * @param {*} param0
 * @param {*} data
 */
export async function getProducts ({ commit, state }, data) {
  await $http.get(`/api/pedidos-vendedor-productos/${data.id}`)
  .then((response) => {
    data.row.item.documents_products = response.data.data
  }).catch((error) => {
    Notification.error({
      title: '¡Error!',
      message: error.message,
      type: 'error',
      duration: 1500,
      customClass: 'notification-box'
    })
    commit('error', error.message)
  })
}

/**
 * obtenemos y seteamos los thread de un documento
 * @param {*} param0
 * @param {*} data
 */
 export async function fetchThreadDocuments ({ commit, state }, data) {
  await $http.get(`/api/pedidos-vendedor-thread/${data.id}`)
  .then((response) => {
    data.item.document_thread = response.data.data
  }).catch((error) => {
    Notification.error({
      title: '¡Error!',
      message: error.message,
      type: 'error',
      duration: 1500,
      customClass: 'notification-box'
    })
    commit('error', error.message)
  })
}

export function setFilterPagination ({ commit, dispatch }, filter) {
	commit('setFilter', filter.target.value)
	dispatch('fetchOrders')
}

export function setPerPagePagination({commit, dispatch}, perPage) {
	commit('setPerPage', parseInt(perPage.target.value))
	dispatch('fetchOrders')
}

export function setPagePagination({ commit, dispatch }, page) {
	commit('setPage', parseInt(page))
	dispatch('fetchOrders')
}

export function setSortByPagination({ commit }, sortBy) {
	commit('setSortBy', sortBy)
}

export function setSortPagination({ commit }, sort) {
	commit('setSort', sort)
}

export async function getSellers({commit, state}, text) {
  let params = { filter:text}
  await $http.get('/api/lista-vendedores', {params} )
    .then((response) => {
      commit('setSellers', response.data.data)
    })
    .catch((error) => {
      Notification.error({
        title: 'Error!',
        message: error.message,
        type: 'error',
        duration: 1500,
        customClass: 'notification-box',
      });
    })
}

//Obtener los parametros de una tabla
export async function getStates({commit, state}) {
  await $http.get(`/api/parametros?paramtable_id=64&paginate=false`)
    .then((response) => {
      commit('setStates', response.data.data)
    })
    .catch((error) => {
      Notification.error({
        title: 'Error!',
        message: error.message,
        type: 'error',
        duration: 2000,
        customClass: 'notification-box',
      });
    })
}

export async function downloadDocument({}, documentToPdf) {

  let name = documentToPdf.vouchertype.name_voucher_type + ' No. ' + documentToPdf.consecutive + '.pdf'

  let url = ''

  if (documentToPdf.operationType_id == 4){
    url ='/api/traslado/descargar-pdf/' + documentToPdf.id
  }else if (documentToPdf.operationType_id == 3){
    url = '/api/traslado/descargar-pdf/' + documentToPdf.thread
  }else{
    url = '/api/documentos/descargar-pdf/' + documentToPdf.id
  }

  await $http({
    url: url,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
  }).catch((error) => {
    Notification.error({
      title: 'Error!',
      message: error.message,
      type: 'error',
      duration: 3000,
      customClass: 'notification-box',
    });

  })
}

//Consultar tercero por id
export async function getContact({ commit, state }, id) {
  //if (state.getContactEdit) {

  await $http
    .get(`/api/terceros/${id}`)
    .then(response => {
      commit("setContact", response.data.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
      commit("contactError", error.message);
    });

  //}
}

export async function fetchUnds({commit, state}, documents){
    let documents_id = []
    await documents.map(doc => {
        documents_id.push(doc.document_id)
    });

    let params = {
      'documents_id' : documents_id
    }
    await $http
        .post(`/api/unds`, params)
        .then(response => {
            commit("setUnds", response.data.data);
        })
        .catch(error => {
            console.error(error);
        });

}



// WEBPACK FOOTER //
// ./src/modules/ordersManagement/actions.js